"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import request from "superagent";
import { Fields, System } from "Constants/objects";

var UserModel =
/*#__PURE__*/
function () {
  function UserModel() {
    _classCallCheck(this, UserModel);
  }

  _createClass(UserModel, [{
    key: "checkLogin",
    value: function checkLogin(cb_true, cb_false) {
      request.get('/wapi/CheckLogin').then(function (res) {
        if (res.status >= 200 && res.status < 300) {
          if (res.body && res.body.ResponseCode === "401") cb_false();else cb_true();
        } else {
          cb_false();
        }
      });
    }
  }, {
    key: "currentUser",
    value: function currentUser() {
      return JSON.parse(localStorage.getItem(System.current_user) || '{}');
    }
  }, {
    key: "getUserID",
    value: function getUserID() {
      var val = this.currentUser()[Fields.UserID];
      return val != null ? Number(val) : null;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.currentUser()[Fields.Name];
    }
  }, {
    key: "getPersonID",
    value: function getPersonID() {
      var val = this.currentUser()[Fields.PersonID];
      return val != null ? Number(val) : null;
    }
  }]);

  return UserModel;
}();

export var user = new UserModel();